import { CheckIcon } from "@/components/shared/Icons";
import { WORKSHOP } from "@/config/workshop";

const ITEMS = [
  `4 Stunden Live-Workshop mit ${WORKSHOP.host}`,
  `Maximal ${WORKSHOP.capacityMax} Teilnehmer für persönliche Betreuung`,
  "Praktische Eigenübungen und direkte Anwendung",
  "Individuelle Übungen für zuhause",
  "Handout mit den wichtigsten Inhalten",
  "Fragen und persönlicher Austausch während des Workshops",
];

export function ValueStack() {
  return (
    <div className="value-stack" data-testid="value-stack">
      <p className="value-intro" data-testid="value-intro">
        Du investierst nicht nur in vier Stunden Workshop. Du investierst in ein besseres
        Verständnis deines Körpers, praktische Werkzeuge für den Alltag und persönliche
        Begleitung in einer kleinen Gruppe.
      </p>
      <h3 className="value-title">Deine Investition beinhaltet</h3>
      <ul className="value-grid" data-testid="value-grid">
        {ITEMS.map((item) => (
          <li key={item}>
            <CheckIcon className="value-check" aria-hidden="true" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
